import { render, staticRenderFns } from "./DetailsCourseItem.vue?vue&type=template&id=21f8c656&scoped=true&"
import script from "./DetailsCourseItem.vue?vue&type=script&lang=js&"
export * from "./DetailsCourseItem.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCourseItem.vue?vue&type=style&index=0&id=21f8c656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f8c656",
  null
  
)

export default component.exports